import {all} from 'redux-saga/effects';

import {wizardValidation} from './wizardValidation/wizardValidation';
import {wizardResets} from './wizardResets/wizardResets';
import {showAlertsForPrescriptionSaga} from './prescription/alerts/alerts';
import {discountPriceSaga} from './discountPrice/discountPrice';
import {prescriptionSaga} from './prescription/prescription';

/**
 * Root wizard ms saga
 */
export function* rootWizardMsSaga() {
    yield all([
        wizardValidation(),
        wizardResets(),
        showAlertsForPrescriptionSaga(),
        discountPriceSaga(),
        prescriptionSaga(),
    ]);
}
